import React, { useMemo, useState, useCallback } from 'react';
import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

import styles from './UserComments.module.scss';
import { TagsEditor } from '@lmt/unicorn-shared/app/components/common/ui-kit/tags/TagsEditor';
import SendIcon from '@lmt/unicorn-shared/app/icons/send.svg?react';
import { UniLink } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/UniLink';

export interface CreateCommentProps {
  sendComment: (comment: string) => void;
}

const maxCount = 365;

export const CreateCommentBlock: React.FC<CreateCommentProps> = (props) => {
  const i18n = useScopedTranslation('patients.overview.comments');
  const [comment, setComment] = useState<string>('');

  const wordCount = useMemo(() => {
    return (
      <div className={styles.commentWordCount}>
        {`${comment.length}/${maxCount}`}
      </div>
    );
  }, [comment.length]);

  const sendOnClick = useCallback(async () => {
    props.sendComment(comment);
    setComment('');
  }, [comment]);

  return (
    <div className={styles.createCommentContainer}>
      <div className={styles.tagsEditorContainer}>
        <TagsEditor
          value={comment}
          onChange={(e, value) => setComment(value)}
          placeholder={i18n.t('placeholder')}
          isMultiline={false}
          maxAutoHeight={100}
          maxLength={maxCount}
        />
      </div>
      <div className={styles.createCommentOptions}>
        <UniLink
          disabled={!comment}
          icon={<SendIcon />}
          title={i18n.t('send_button')}
          onClick={sendOnClick}
          color={ButtonColor.Primary}
          className={styles.createCommentButton}
        />
        {comment.length > maxCount / 2 && wordCount}
      </div>
    </div>
  );
};
